module.exports = __webpack_public_path__ + "img/logo.09e091c5.svg";